export default __webpack_public_path__ + "static/media/NIAS0170.34I-32771_-24642_0.02ddf4dd.jpg";